// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Workspace List component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var EventUtils = require('EventUtils');

  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  var List = require('share/components/controls/Izenda.List');
  var WorkspaceItem = require('./Izenda.WorkspaceItem');

  var notifyChange = EventUtils.notifyChange;
  var notify = EventUtils.notify;

  var observer = require('mobx-react').observer;

  var WorkspaceList = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },
    render: function () {
      return (
        <div className="workspace-panel u_fullHeight u-posRelative">
          {this.getRenderHeaderContent()}
          {this.getRenderListWorkspace()}
      </div>
      );
    },

    getRenderHeaderContent: function () {
      var store = this.props.store;
      var localization = this.props.localization;

      return (
        <div className="header-panel">
          <a
            className="connection-builder-link btn-add-connection overflow-text text-bold"
            onClick={this.addNewWorkspace}
            title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ADD_WORKSPACE')}>
            <span className="icon-plus"/>
             {localization.getText('COPY_MANAGEMENT_WORK_SPACE_LIST_ADD_WORKSPACE')}
          </a>
          <div className="search-box">
            <SearchTextBox value={store.filter}
              onChange={notifyChange(store.setFilter.bind(store), EventUtils.INPUT)}
              onKeyPress={this.selectSearchedWorkspace}/>
          </div>
          <div className="checkbox-show-workspace overflow-text">
            <input type='checkbox'
                   checked={store.showOnlyMyWorkspace}
                   onClick={this.onChangeOnlyShowMyWorkspace}
                   className='u_noMarginLeft'
                   id='showOnlyMyWorkspace' />
            <label htmlFor='showOnlyMyWorkspace' className='u_textNormal'>{localization.getText('COPY_MANAGEMENT_WORK_SPACE_LIST_SHOW_ONLY_MY_WORKSPACES')}</label>
          </div>
          <hr />
        </div>
      );
    },

    getRenderListWorkspace: function () {
      var store = this.props.store;

      return (
        <div className="list-workspace-item">
          <ScrollBox>
            <List itemClass="workspace-item-custom">
              {store.filteredWorkspaces.map(function (item, idx){
                return (
                  <WorkspaceItem
                    key={idx}
                    dataSource={item}
                    store={store} >
                  </WorkspaceItem>
                );
              })}
            </List>
          </ScrollBox>
        </div>
      );
    },

    /**
     * When there is only one item in searched workspace list, user can press enter
     * to select it.
     * @param  {Object} event React-event
     */
    selectSearchedWorkspace: function (event){
      if(event.key === 'Enter'){
        var store = this.props.store;
        if(store.filteredWorkspaces.length === 1){
          store.item = store.filteredWorkspaces[0];
        }
      }
    },

    /**
     * Add a new workspace. New workspace detail is showed.
     */
    addNewWorkspace: function () {
      this.props.store.filter = '';
      this.props.store.addWorkspace();
    },

    onChangeOnlyShowMyWorkspace: function (event) {
      var store = this.props.store;
      store.updateShowWorkspace(event.target.checked);
      store.loadList(store.tenantId).then(store.handleShowMyWorkspace.bind(store));
    }
  });

  module.exports = observer(connect()(WorkspaceList));
}())



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceList/Izenda.WorkspaceList.jsx